module.exports = __webpack_public_path__ + "img/left-img.25c790f2.png";